let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kFOec"), load("hD56l"), load("6G4QQ")]).then(() => parcelRequire('dzOK8'));